export default "__VITE_ASSET__DfOLxRMY__"